module.exports = __webpack_public_path__ + "static/favicon-ff8049ed6dc723173d0d395a78bc17c9.png";